import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import EventTarget from './EventTarget';

var _requestHeader = new Map();

var _responseHeader = new Map();

var _requestTask = new Map();

var contentTypes = {
  json: 'application/json',
  text: 'application/text',
  arraybuffer: 'application/octet-stream'
};

function _triggerEvent(type) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    target: this
  };

  if (typeof this["on".concat(type)] === 'function') {
    this["on".concat(type)].call(this, event);
  }
}

function _changeReadyState(readyState) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    readyState: readyState
  };
  this.readyState = readyState;

  _triggerEvent.call(this, 'readystatechange', event);
}

export var $XMLHttpRequest = function (_EventTarget) {
  _inherits($XMLHttpRequest, _EventTarget);

  var _super = _createSuper($XMLHttpRequest);

  function $XMLHttpRequest() {
    var _this;

    _classCallCheck(this, $XMLHttpRequest);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onabort", void 0);

    _defineProperty(_assertThisInitialized(_this), "onerror", void 0);

    _defineProperty(_assertThisInitialized(_this), "onload", void 0);

    _defineProperty(_assertThisInitialized(_this), "onloadstart", void 0);

    _defineProperty(_assertThisInitialized(_this), "onprogress", void 0);

    _defineProperty(_assertThisInitialized(_this), "ontimeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "onloadend", void 0);

    _defineProperty(_assertThisInitialized(_this), "onreadystatechange", void 0);

    _defineProperty(_assertThisInitialized(_this), "readyState", void 0);

    _defineProperty(_assertThisInitialized(_this), "response", void 0);

    _defineProperty(_assertThisInitialized(_this), "responseText", void 0);

    _defineProperty(_assertThisInitialized(_this), "_responseType", void 0);

    _defineProperty(_assertThisInitialized(_this), "responseXML", void 0);

    _defineProperty(_assertThisInitialized(_this), "status", void 0);

    _defineProperty(_assertThisInitialized(_this), "statusText", void 0);

    _defineProperty(_assertThisInitialized(_this), "upload", void 0);

    _defineProperty(_assertThisInitialized(_this), "withCredentials", void 0);

    _defineProperty(_assertThisInitialized(_this), "timeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "_url", void 0);

    _defineProperty(_assertThisInitialized(_this), "_method", void 0);

    _this.onabort = null;
    _this.onerror = null;
    _this.onload = null;
    _this.onloadstart = null;
    _this.onprogress = null;
    _this.ontimeout = null;
    _this.onloadend = null;
    _this.onreadystatechange = null;
    _this.readyState = 0;
    _this.response = null;
    _this.responseText = null;
    _this._responseType = 'text';
    _this.responseXML = null;
    _this.status = 0;
    _this.statusText = '';
    _this.upload = {};
    _this.withCredentials = false;

    _requestHeader.set('requestHeader', {
      'content-type': 'application/x-www-form-urlencoded'
    });

    return _this;
  }

  _createClass($XMLHttpRequest, [{
    key: "responseType",
    set: function set(type) {
      this._responseType = type;
    }
  }, {
    key: "abort",
    value: function abort() {
      var myRequestTask = _requestTask.get('requestTask');

      if (myRequestTask) {
        myRequestTask.abort();
      }
    }
  }, {
    key: "getAllResponseHeaders",
    value: function getAllResponseHeaders() {
      var responseHeader = _responseHeader.get('responseHeader');

      return Object.keys(responseHeader).map(function (header) {
        return "".concat(header, ": ").concat(responseHeader[header]);
      }).join('\n');
    }
  }, {
    key: "getResponseHeader",
    value: function getResponseHeader(header) {
      return _responseHeader.get('responseHeader')[header];
    }
  }, {
    key: "open",
    value: function open(method, url, flag) {
      this._method = method;
      this._url = url;
    }
  }, {
    key: "overrideMimeType",
    value: function overrideMimeType() {}
  }, {
    key: "send",
    value: function send() {
      var $data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    }
  }, {
    key: "setRequestHeader",
    value: function setRequestHeader(header, value) {
      var myHeader = _requestHeader.get('requestHeader');

      myHeader[header] = value;

      _requestHeader.set('requestHeader', myHeader);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      var _this2 = this;

      if (typeof listener !== 'function') {
        return;
      }

      this['on' + type] = function () {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        event.target = event.target || _this2;
        listener.call(_this2, event);
      };
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      if (this['on' + type] === listener) {
        this['on' + type] = null;
      }
    }
  }]);

  return $XMLHttpRequest;
}(EventTarget);

_defineProperty($XMLHttpRequest, "UNSEND", void 0);

_defineProperty($XMLHttpRequest, "OPENED", void 0);

_defineProperty($XMLHttpRequest, "HEADERS_RECEIVED", void 0);

_defineProperty($XMLHttpRequest, "LOADING", void 0);

_defineProperty($XMLHttpRequest, "DONE", void 0);

$XMLHttpRequest.UNSEND = 0;
$XMLHttpRequest.OPENED = 1;
$XMLHttpRequest.HEADERS_RECEIVED = 2;
$XMLHttpRequest.LOADING = 3;
$XMLHttpRequest.DONE = 4;
//# sourceMappingURL=XMLHttpRequest.js.map